import mailto from '@/business/mailto/mailto';

export interface ActionBuildItem {
  isEditing: boolean;
  diagnostic: string;
  item: any;
  staffsInCharge: any[];
}

export default class ActionTemplate {
  private buildItem: ActionBuildItem;

  private readonly deadline: string;

  constructor(buildItem: ActionBuildItem) {
    this.buildItem = JSON.parse(JSON.stringify(buildItem));
    this.deadline = buildItem.item.deadline_datetime
      ? new Date(buildItem.item.deadline_datetime).toLocaleDateString()
      : 'NC';
  }

  buildEMailsStr(): string {
    const staffs = this.buildItem.staffsInCharge;
    return staffs
      .filter(
        (el, index) =>
          el &&
          el.user_gid &&
          index === staffs.findIndex((item) => item.user_gid === el.user_gid)
      )
      .map((el) => `${el.user_gid}@engie.com`)
      .join(';');
  }

  buildSubjectStr(): string {
    const subject = `[Action MyPredity] Installation : ${this.buildItem.item.node_associated_code} ${this.buildItem.item.node_associated_shortname}`;
    if (this.buildItem.isEditing) {
      return `[Mise à jour]${subject}`;
    }
    return subject;
  }

  buildBodyStr(): string {
    return `Bonjour,
L’Installation n°${this.buildItem.item.node_associated_code}, ${this.buildItem.item.node_associated_shortname}
A fait l’objet d’une analyse par l’équipe Predity :
${this.buildItem.diagnostic}

Une action est nécessaire :
[Action n°${this.buildItem.item.id}]
Description : ${this.buildItem.item.description}

Priorité : ${this.buildItem.item.priority_name}
Type : ${this.buildItem.item.type_name}
Date limite de réalisation : ${this.deadline}

Merci de faire le nécessaire pour compléter la prochaine intervention avec ces informations.

Cordialement.

L’équipe MyPredity 
`;
  }

  mailto(errorHandler?: () => void) {
    const body = this.buildBodyStr();
    const subject = this.buildSubjectStr();
    const emails = this.buildEMailsStr();
    const url = mailto(emails, subject, body);
    if (url.length > 2042) {
      if (errorHandler) errorHandler();
      return this.handleTooLongMailto();
    }
    return url;
  }

  handleTooLongMailto() {
    this.buildItem.item.description = `${this.buildItem.item.description.slice(
      0,
      -10
    )} ...`;
    this.buildItem.diagnostic = `${String(
      this.buildItem.diagnostic.slice(0, -10)
    )} ...`;
    return this.mailto();
  }
}
